/* ============================================================
   CARDIFF BAKING COMPANY THEME — theme.js
   ============================================================ */

(function () {
  'use strict';

  /* ── MOBILE MENU ── */
  const mobileToggle = document.getElementById('mobile-menu-toggle');
  const mobileNav    = document.getElementById('mobile-nav');

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      const open = mobileNav.classList.toggle('open');
      mobileToggle.setAttribute('aria-expanded', open);
      mobileNav.setAttribute('aria-hidden', !open);
    });
  }

  /* ── SEARCH BAR ── */
  const searchToggle = document.getElementById('search-toggle');
  const searchClose  = document.getElementById('search-close');
  const searchBar    = document.getElementById('search-bar');

  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      searchBar.classList.toggle('open');
      searchBar.setAttribute('aria-hidden', !searchBar.classList.contains('open'));
      if (searchBar.classList.contains('open')) {
        searchBar.querySelector('input').focus();
      }
    });
  }
  if (searchClose && searchBar) {
    searchClose.addEventListener('click', function () {
      searchBar.classList.remove('open');
      searchBar.setAttribute('aria-hidden', 'true');
    });
  }

  /* ── CART DRAWER ── */
  const cartToggle  = document.getElementById('cart-toggle');
  const cartDrawer  = document.getElementById('cart-drawer');
  const cartClose   = cartDrawer ? cartDrawer.querySelector('.cart-drawer__close') : null;
  const cartOverlay = cartDrawer ? cartDrawer.querySelector('.cart-drawer__overlay') : null;

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartToggle)  cartToggle.addEventListener('click', openCartDrawer);
  if (cartClose)   cartClose.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  /* ── FETCH & RENDER CART ── */
  function fetchCart() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => renderCartDrawer(cart))
      .catch(err => console.error('Cart fetch error:', err));
  }

  function renderCartDrawer(cart) {
    const body    = document.getElementById('cart-drawer-body');
    const footer  = document.getElementById('cart-drawer-footer');
    const subtotal = document.getElementById('cart-subtotal');
    const count   = document.getElementById('cart-count');

    if (count) {
      if (cart.item_count > 0) {
        count.textContent = cart.item_count;
        count.style.display = 'flex';
      } else {
        count.style.display = 'none';
      }
    }

    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      if (footer) footer.style.display = 'none';
      return;
    }

    let html = '';
    cart.items.forEach(function (item) {
      html += `
        <div class="cart-drawer-item" data-key="${item.key}">
          <a href="${item.url}" class="cart-drawer-item__img">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
          </a>
          <div class="cart-drawer-item__info">
            <a href="${item.url}" class="cart-drawer-item__name">${item.product_title}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-drawer-item__variant">${item.variant_title}</p>` : ''}
            <div class="cart-drawer-item__row">
              <div class="qty-selector qty-selector--small">
                <button type="button" class="qty-btn cart-drawer-qty" data-key="${item.key}" data-action="minus">−</button>
                <span class="cart-drawer-qty-display">${item.quantity}</span>
                <button type="button" class="qty-btn cart-drawer-qty" data-key="${item.key}" data-action="plus">+</button>
              </div>
              <span class="cart-drawer-item__price">${formatMoney(item.line_price)}</span>
            </div>
          </div>
          <button class="cart-drawer-remove" data-key="${item.key}" aria-label="Remove">&#x2715;</button>
        </div>`;
    });

    body.innerHTML = html;
    if (footer) footer.style.display = 'block';
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    // Quantity buttons in drawer
    body.querySelectorAll('.cart-drawer-qty').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const key    = btn.dataset.key;
        const action = btn.dataset.action;
        const display = btn.parentElement.querySelector('.cart-drawer-qty-display');
        let qty = parseInt(display.textContent, 10);
        qty = action === 'plus' ? qty + 1 : Math.max(0, qty - 1);
        updateCartItem(key, qty);
      });
    });

    // Remove buttons in drawer
    body.querySelectorAll('.cart-drawer-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateCartItem(btn.dataset.key, 0);
      });
    });
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(res => res.json())
      .then(cart => renderCartDrawer(cart))
      .catch(err => console.error('Cart update error:', err));
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ── ADD TO CART (product card quick-add) ── */
  document.querySelectorAll('.product-card__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const variantId = form.querySelector('[name="id"]').value;
      const btn = form.querySelector('.product-card__atc');
      const originalText = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(res => res.json())
        .then(function () {
          btn.textContent = 'Added!';
          openCartDrawer();
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          btn.textContent = 'Error';
          btn.disabled = false;
        });
    });
  });

  /* ── PRODUCT PAGE ── */
  const productForm = document.getElementById('product-form');
  if (productForm) {

    // Add to cart
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const variantId = document.getElementById('variant-id').value;
      const qty = document.getElementById('qty') ? parseInt(document.getElementById('qty').value, 10) : 1;
      const btn = document.getElementById('add-to-cart-btn');
      const originalText = btn.textContent;

      btn.textContent = 'Adding…';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(res => res.json())
        .then(function () {
          btn.textContent = 'Added!';
          openCartDrawer();
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          btn.textContent = 'Error — try again';
          btn.disabled = false;
        });
    });

    // Variant selection
    const optionBtns = document.querySelectorAll('.option-btn');
    if (optionBtns.length > 0) {
      const variantData = window.__variantData || [];

      optionBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          const index = parseInt(btn.dataset.optionIndex, 10);

          // Update active state
          document.querySelectorAll(`.option-btn[data-option-index="${index}"]`).forEach(function (b) {
            b.classList.remove('active');
          });
          btn.classList.add('active');

          // Find matching variant
          const selectedValues = [];
          document.querySelectorAll('.product-option').forEach(function (group, i) {
            const active = group.querySelector('.option-btn.active');
            if (active) selectedValues[i] = active.dataset.value;
          });

          if (variantData.length) {
            const match = variantData.find(function (v) {
              return v.options.every(function (opt, i) {
                return opt === selectedValues[i];
              });
            });

            if (match) {
              document.getElementById('variant-id').value = match.id;
              const priceEl = document.getElementById('product-price');
              if (priceEl && match.price) {
                priceEl.innerHTML = formatMoney(match.price);
              }
              const atcBtn = document.getElementById('add-to-cart-btn');
              if (atcBtn) {
                if (match.available) {
                  atcBtn.textContent = 'Add to Cart';
                  atcBtn.disabled = false;
                } else {
                  atcBtn.textContent = 'Sold Out';
                  atcBtn.disabled = true;
                }
              }
            }
          }
        });
      });
    }

    // Quantity selector
    const qtyMinus = document.getElementById('qty-minus');
    const qtyPlus  = document.getElementById('qty-plus');
    const qtyInput = document.getElementById('qty');

    if (qtyMinus && qtyPlus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        const val = parseInt(qtyInput.value, 10);
        if (val > 1) qtyInput.value = val - 1;
      });
      qtyPlus.addEventListener('click', function () {
        qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      });
    }
  }

  /* ── PRODUCT IMAGE GALLERY ── */
  const thumbs    = document.querySelectorAll('.gallery-thumb');
  const mainImg   = document.getElementById('gallery-main-img');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) mainImg.src = thumb.dataset.src;
    });
  });

  /* ── STICKY HEADER SHADOW ── */
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 2px 20px rgba(0,0,0,0.06)';
      } else {
        header.style.boxShadow = '';
      }
    });
  }

  /* ── INIT CART COUNT ON LOAD ── */
  fetch('/cart.js')
    .then(res => res.json())
    .then(function (cart) {
      const count = document.getElementById('cart-count');
      if (count && cart.item_count > 0) {
        count.textContent = cart.item_count;
        count.style.display = 'flex';
      }
    })
    .catch(function () {});

})();
